import { captureAffiliateReferral } from './utils/affiliateAttribution';
captureAffiliateReferral();
import Vue from "vue";
import App from "./App.vue";
import VideoGuide from "./components/VideoGuide.vue";
Vue.component("VideoGuide", VideoGuide);
import VueMoment from "vue-moment";
import VueMeta from "vue-meta";
import VueClipboard from 'vue-clipboard2'
import VueApexCharts from 'vue-apexcharts'
import Vue2Editor from "vue2-editor";
import VueCookie from 'vue-cookie';

import axios from "axios";
import router from "./router";
import store from "./store";
import vuetify from './plugins/vuetify';
import Vuetify from 'vuetify/lib'

import VueSweetalert2 from 'vue-sweetalert2';
import LoadingOverlay from 'vue-swal2-loading-overlay';

import Gravatar from 'vue-gravatar';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'

import vClickOutside from 'v-click-outside'

// Check before rendering a private screen; the backend enforces the same restriction.
router.beforeEach(async (to, from, next) => {
  const token = store.state.auth.jwt
  if (!token || to.path === '/login' || to.path === '/agency-welcome') { return next() }
  try {
    const { data } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/access-status`, {
      headers: { Authorization: 'Bearer ' + token }
    })
    if (data.pending) { return next('/agency-welcome') }
    next()
  } catch (error) {
    if (error.response && error.response.status === 401) { await store.dispatch('auth/logout'); return next('/login') }
    if (error.response && error.response.data && error.response.data.code === 'agency_approval_required') { return next('/agency-welcome') }
    // A temporary outage or an older backend must not lock existing accounts out.
    // Protected API requests still enforce approval on the server.
    next()
  }
})

let appName = 'LSA'

if (window.location.origin != process.env.VUE_APP_MAIN_URL && window.location.origin != process.env.VUE_APP_MAIN_URL_CODESPACE) {
  axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/get-agency-details` + "?host=" + window.location.host).then(function(response) {
    if (response.data.success) {
      appName = response.data.agency.company_name

      Vue.use({
        install() {
          Vue.agency = response.data.agency;
          Vue.prototype.$agency = response.data.agency;
          Vue.appName = response.data.agency.company_name;
          Vue.prototype.$appName = response.data.agency.company_name;
        }
      });

      continueLoadingApp()
    }
    else {
      return "Not a valid domain."
    }
  });
}
else {
  Vue.use({
    install() {
      Vue.agency = null;
      Vue.prototype.$agency = null;
      Vue.appName = appName;
      Vue.prototype.$appName = appName;
    }
  });

  continueLoadingApp()
}

function continueLoadingApp() {
  let parent_id = '';
  let loggedIn = false;

  let vuex = {auth: {jwt: null}};

  try {
    vuex = JSON.parse(window.localStorage.vuex);
  }
  catch (e) {}

  // console.log('vuex', vuex)

  if (vuex.auth.jwt) {
    try {
      axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me?field=parent_id`, {
        headers: {
          'Authorization': 'Bearer ' + vuex.auth.jwt
        }
      }).then(function(response) {
        // console.log('response.data', response.data)
        parent_id = response.data.parent_id;
        loggedIn = true;
        continueLoadingApp2();
      }).catch(function (error) {
        continueLoadingApp2();
      });
    }
    catch (e) {
      continueLoadingApp2();
    }
  }
  else {
    continueLoadingApp2();
  }
  
  function continueLoadingApp2() {
    Vue.use(VueMoment);
    Vue.use(VueMeta);

    Vue.component('v-gravatar', Gravatar);

    Vue.use(VueSweetalert2);

    Vue.use(LoadingOverlay);

    Vue.use(VueClipboard)

    Vue.use(Vuetify)


    Vue.use(VueApexCharts)

    Vue.component('apexchart', VueApexCharts)

    Vue.use(VueCookie);

    // Make BootstrapVue available throughout your project
    Vue.use(BootstrapVue)
    // Optionally install the BootstrapVue icon components plugin
    Vue.use(IconsPlugin)

    Vue.use(Vue2Editor);

    Vue.use(vClickOutside)

    Vue.use({
      install() {
          Vue.appName = appName;
          Vue.prototype.$appName = appName;
      }
    });

    new Vue({
      router
    });

    axios.interceptors.request.use((config) => {
      config.headers['RG-Auth-Loc-Ua'] = store.state.auth.jwt;
      return config
    })

    axios.interceptors.response.use(undefined, async function (error) {
      if (error.response && error.response.data && error.response.data.code === 'agency_approval_required') {
        if (router.currentRoute.path !== '/agency-welcome') router.replace('/agency-welcome').catch(() => {})
      }
      if (error.response && error.response.status === 401) {
        await store.dispatch("auth/logout");
        router.push("/login");
      }
      return Promise.reject(error);
    });

    // Plugins
    // ...

    // Sass file
    require("./assets/styles/main.css");

    Vue.config.productionTip = false;

    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App)
    }).$mount("#app");
  }
}